import { useLocation, useHistory } from "react-router-dom";
import { useMemo, useCallback } from "react";

/**
 * A React hook to use URL search params as a JSON object.
 * Works with React Router v5.
 */
const useCustomURLParams = () => {
  const location = useLocation();
  const history = useHistory();

  // Parse search string into an object
  const queryObject = useMemo(() => {
    const params = new URLSearchParams(location.search);
    const obj = {};
    for (const [key, value] of params.entries()) {
      obj[key] = value;
    }
    return obj;
  }, [location.search]);

  // Update the query params
  const setQueryObject = useCallback(
    (newParams) => {
      const params = new URLSearchParams(location.search);

      Object.entries(newParams).forEach(([key, value]) => {
        if (value === undefined || value === null || value === "") {
          params.delete(key);
        } else {
          params.set(key, value);
        }
      });

      const newSearch = params.toString();
      const newUrl = `${location.pathname}${newSearch ? `?${newSearch}` : ""}`;

      history.push(newUrl);
    },
    [location.pathname, location.search, history]
  );

  return [queryObject, setQueryObject];
};

export default useCustomURLParams;